import { render, staticRenderFns } from "./orderman_id.vue?vue&type=template&id=0f09da90"
import script from "./orderman_id.vue?vue&type=script&lang=js"
export * from "./orderman_id.vue?vue&type=script&lang=js"
import style0 from "./orderman_id.vue?vue&type=style&index=0&id=0f09da90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports